import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';
import { PRINCIPAL_FRAGMENT } from '@app/model/authentication/service/AuthorizationGraphQlFragments';


export const FIND_PROFILE_QUERY: GraphQL = {
    name: "findProfile",
    gql: gql`
        query findProfile {
            findProfile {
                id
                name
                username
                email
                creationDate
                imageUrl
                department {
                    id
                    name
                }
                company {
                    id
                    name
                    country {
                        id
                        name
                    }
                }
            }
        }
    `
}
export const FIND_PROFILE_INTERCOM_HASH: GraphQL = {
    name: "findIntercomHash",
    gql: gql`
        query findIntercomHash {
            findIntercomHash
        }
    `
}

export const SAVE_PROFILE_MUTATION: GraphQL = {
    name: "saveProfile",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation saveProfile($input:ProfileInput!) {
            saveProfile(input: $input) {
                ...PrincipalFields
            }
        }
    `
}

export const CHANGE_PASSWORD_MUTATION: GraphQL = {
    name: "changePassword",
    gql: gql`
        mutation changePassword($input:ChangePasswordInput!) {
            changePassword(input: $input) {
                exception
                success
            }
        }
    `
}

export const RESET_PASSWORD_REQUEST_MUTATION: GraphQL = {
    name: "resetPasswordRequest",
    gql: gql`
        mutation resetPasswordRequest($email:String!) {
            resetPasswordRequest(email: $email)  {
                success
                exception
            }
        }
    `
}

export const RESET_PASSWORD_MUTATION: GraphQL = {
    name: "resetPassword",
    gql: gql`
        mutation resetPassword($input:ResetPasswordInput!) {
            resetPassword(input: $input) {
                exception
                success
            }
        }
    `
}
export const CHANGE_PARITY_USER_TO_REV_HERO_USER_MUTATION: GraphQL = {
    name: "changeParityUserToRevHeroUser",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation changeParityUserToRevHeroUser($code:String!) {
            changeParityUserToRevHeroUser(code: $code) {
                ...PrincipalFields
            }
        }
    `
}